import { createSlice, createAsyncThunk, rejectWithValue } from '@reduxjs/toolkit'
import {API_CALL_STATUS, WORK_ORDER_STATUSES} from '../../metadata/enums'
import {FETCH_WORK_ORDERS, UPDATE_WORK_ORDER_STATUS, FETCH_ONE_WORK_ORDER} from "../actionTypes";
import Config from "../../config";
import axios from "axios";
import {LOGGER} from "../../utils/Logger";
import {getSettingsData} from "./settingsSlice";

const initialState = {
	work_orders: [],
	active_underwriting: null,
	active_underwriting_id: null,
	status: API_CALL_STATUS.IDLE,
	error: null,
	updated_work_order_status: false
}

export const fetchWorkOrders = createAsyncThunk(FETCH_WORK_ORDERS, async (payload) => {
	let {sort, filter} = payload
	let temp = ''
	if(sort && Object.keys(sort).length > 0) {
		for(let key in sort) {
			temp += `${key}:${sort[key]},`
		}
	} else {
		temp = 'work_order_updated_at:-1,'
	}
	temp = temp.substring(0, temp.length - 1)

	let temp2 = ''
	if(filter && Object.keys(filter).length > 0) {
		// add filter conditions here
		for(let key in filter) {
			let array = filter[key]
			temp2 += `${key}:${array.join('|')},`
		}
	}
	temp2 = temp2.substring(0, temp2.length - 1)
	console.log('filed filters are', temp2)


	let headers = {Authorization: payload.token}
	if(payload.workOrderCostFilters && Object.keys(payload.workOrderCostFilters).length > 0) {
		let filters = payload.workOrderCostFilters
		if(filters['min'] && filters['min'].length > 0)
			headers['wo_min'] = filters['min']
		if(filters['max'] && filters['max'].length > 0)
			headers['wo_max'] = filters['max']
	}

	const config = {
		method: 'get',
		url: `${Config.BACKEND_URL}work-orders?status=${payload.status}&page=${payload.page || 1}&sort=${temp}&filter=${temp2}`,
		headers: headers
	}
	let res = await axios(config)
	return res.data
})

export const updateWorkOrderStatus = createAsyncThunk(UPDATE_WORK_ORDER_STATUS, async (payload) => {
	console.log('updating work order status', payload.workOrder)
	try {
		let _id = payload.workOrder._id
		const config = {
			method: 'put',
			url: `${Config.BACKEND_URL}work-orders/${_id}`,
			headers: {Authorization: payload.token},
			data: payload.workOrder,
		}
		let res = await axios(config)
		return payload.workOrder
	}catch (error) {
		LOGGER.error('Error when updating work order status', error)
    throw error
	}
})

export const fetchOneWorkOrder = createAsyncThunk(FETCH_ONE_WORK_ORDER, async (payload) => {
	const config = {
		method: 'get',
		url: `${Config.BACKEND_URL}work-orders/${payload._id}`,
		headers: {Authorization: payload.token},
	}
	let res = await axios(config)
	return res.data
})




const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		updateActiveUnderwriting(state, action) {
			return Object.assign({}, state, {active_underwriting: action.payload})
		},
		updateActiveUnderwritingId(state, action) {
			return Object.assign({}, state, { active_underwriting_id: action.payload})
		},
		updateWorkOrderStatusFlag(state, action) {
			return Object.assign({}, state, {updated_work_order_status: action.payload})
		}
	},
	extraReducers(builder) {
		builder
		.addCase(fetchOneWorkOrder.pending, (state, action) => {
			state.status = API_CALL_STATUS.LOADING
		})
		.addCase(fetchOneWorkOrder.fulfilled, (state, action) => {
			state.status = API_CALL_STATUS.SUCCEEDED
			state.active_underwriting = action.payload
			state.active_underwriting_id = action.payload?._id || null
		})
		.addCase(fetchOneWorkOrder.rejected, (state, action) => {
			state.status = API_CALL_STATUS.FAILED
			state.error = action.error.message
		})
		.addCase(fetchWorkOrders.pending, (state, action) => {
			state.status = API_CALL_STATUS.LOADING
		})
		.addCase(fetchWorkOrders.fulfilled, (state, action) => {
			state.status = API_CALL_STATUS.SUCCEEDED
			state.work_orders = action.payload
		})
		.addCase(fetchWorkOrders.rejected, (state, action) => {
			state.status = API_CALL_STATUS.FAILED
			state.error = action.error.message
		})
		.addCase(updateWorkOrderStatus.pending, (state, action) => {
			state.status = API_CALL_STATUS.LOADING
		})
		.addCase(updateWorkOrderStatus.fulfilled, (state, action) => {
			state.status = API_CALL_STATUS.SUCCEEDED
			state.work_orders.forEach(workOrder => {
        if (workOrder._id === action.payload._id)
          workOrder.status = action.payload.status
      })
			state.active_underwriting = action.payload
			state.updated_work_order_status = true
		})
		.addCase(updateWorkOrderStatus.rejected, (state, action) => {
			state.status = API_CALL_STATUS.FAILED
			state.error = action.error.message
		})
	}
})


export const {updateActiveUnderwriting, updateWorkOrderStatusFlag, updateActiveUnderwritingId } = authSlice.actions

export default authSlice.reducer
